export function getResponseErrorMessage(error) {
  /** Return an error message from a query/mutation's error object. */
  if (error?.response?.data?.nonFieldErrors)
    return error.response.data.nonFieldErrors[0]
  else if (error?.response?.data?.detail)
    return error.response.data.detail

  return null;
}
